import safeLocalStorage from 'safe-localstorage';

export default () => {
  const recentConnections = safeLocalStorage.get('assets/recentConnections');

  return {
    assets: {},
    batteryHistory: {},
    batteryHistoryLoading: false,
    hoveredLocationFromList: false,
    locationHistory: [],
    locationHistoryLoading: false,
    temperatureHistory: {},
    temperatureHistoryLoading: false,
    editDialog: null,
    hoveredLocationHistoryId: null,
    locations: {},
    recentConnections: recentConnections ? recentConnections.split(',') : [],
    selectedKey: null,
    assetTypes: {},
    assetTypesLoading: false,
  };
};
